import { mergeMap, tap } from 'rxjs/operators';
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import { selectEventConfigsInStore, selectEventConfigsPageLoading, selectEventConfigsShowInitWaitingMessage } from '../_selectors/EventConfig.selectors';


export class EventConfigsDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
        super();

		this.loading$ = this.store.pipe(
			select(selectEventConfigsPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectEventConfigsShowInitWaitingMessage)
        );
        
        this.store.pipe(
			select(selectEventConfigsInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});

    }
}